import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import { FormGroup, ControlLabel, HelpBlock } from "react-bootstrap";
import Select from "react-select";
import _ from "lodash";
import "react-select/dist/react-select.css";
import "./index.css";

class SensorTypeDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultSensorType: "",
      selectedSensorType: this.props.defaultValue ? this.props.defaultValue : undefined
    };
  }

  componentDidMount() {
    const { list } = this.props;
    if (list) {
      this.setState({
        sensorTypeList: list
      });
    }
  }

  filterDisciplines = () => {
    const { configList, list } = this.props;
    const sensorTypePermittedForObservation = configList.permissions.observations[0].disciplines;
    const filteredList = _.filter(list, item => _.includes(sensorTypePermittedForObservation, item.id));
    return filteredList;
  };

  componentDidUpdate(prevProps) {
    const { list, reset } = this.props;
    if (list !== prevProps.list && list) {
      this.setState({
        sensorTypeList: this.props.list
      });
    }

    if (reset !== prevProps.reset) {
      this.setState({
        selectedSensorType: ""
      });
      this.props.change("");
    }
  }

  handleChange = selectedOption => {
    const { observationPage } = this.props;
    this.setState({ selectedSensorType: selectedOption });
    if (selectedOption) {
      if (!observationPage) {
        this.props.change(selectedOption.map(c => c.id));
      } else {
        this.props.change(selectedOption.id);
      }
    }
  };

  render = () => {
    const { observationPage, configList, observationValidated } = this.props;
    const { sensorTypeList, selectedSensorType } = this.state;
    if (configList && sensorTypeList) {
      return (
        <div className="precinct">
          <FormGroup
            controlId="formControlsSelect"
            validationState={observationPage && observationValidated && !selectedSensorType ? "error" : null}
          >
            <ControlLabel>{observationPage ? "Discipline" : "Disciplines"}</ControlLabel>
            <Select
              name="form-field-name"
              value={selectedSensorType}
              onChange={this.handleChange}
              valueKey="id"
              labelKey="name"
              multi={!observationPage ? true : false}
              options={observationPage ? this.filterDisciplines() : sensorTypeList}
              placeholder={observationPage ? "Select a discipline" : "All disciplines"}
            />
            {observationPage && observationValidated && !selectedSensorType ? (
              <HelpBlock>
                <FontAwesome name="exclamation-circle" />Please select a discipline.
              </HelpBlock>
            ) : null}
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  const { list } = state.disciplinesList;
  return {
    user,
    configList,
    list
  };
}

export default connect(mapStateToProps)(SensorTypeDropdown);



// WEBPACK FOOTER //
// ./src/_components/SensorTypeDropdown/index.js